import styled from 'styled-components';

export const DetailsInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
